/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateQuotaRequest
 */
export interface UpdateQuotaRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateQuotaRequest
     */
    soft?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateQuotaRequest
     */
    hard?: number | null;
}

export function UpdateQuotaRequestFromJSON(json: any): UpdateQuotaRequest {
    return UpdateQuotaRequestFromJSONTyped(json, false);
}

export function UpdateQuotaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateQuotaRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'soft': !exists(json, 'soft') ? undefined : json['soft'],
        'hard': !exists(json, 'hard') ? undefined : json['hard'],
    };
}

export function UpdateQuotaRequestToJSON(value?: UpdateQuotaRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'soft': value.soft,
        'hard': value.hard,
    };
}


